import styled from 'styled-components'

export const S_Div = styled.form`
  margin: auto;
`
